/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PharmacyApi } from '../api/pharmacy.api';
import { switchMap, map } from 'rxjs/operators';
import { PharmacyData, Pharmacy } from '../../../interfaces/masters/pharmacy';

@Injectable()
export class PharmacyService extends PharmacyData {

  constructor(private api: PharmacyApi) {
    super();
  }



  list(url: string): Observable<Pharmacy[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Pharmacy>{
      return this.api.getById(url);
  }

  create(url: string, data:Pharmacy): Observable<Pharmacy> {
    return this.api.add(url,data);
  }

  update(url: string, data:Pharmacy): Observable<Pharmacy> {
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
